<template>
  <div class="bb-sending">
    <div class="bb-sending__status">
      {{errorText}}
    </div>
    <i class="icon-cross-big bb-sending__close" @click="hideModal()"/>
  </div>
</template>

<script>
export default {
  name: 'SendingStatus',
  props: ['errorText', 'close'],
  data () {
    return {
      openStatus: true
    }
  },
  computed: {
    newMessage: {
      get: function () {
        return this.$store.getters.newMessage
      },
      set: function (data) {
        this.$store.dispatch('setNewMessage', data)
      }
    }
  },
  methods: {
    hideModal () {
      this.errorText ? this.close() : this.newMessage.status = false
    }
  },
  beforeMount () {
    const hideModal = this.errorText ? this.close : this.hideModal
    setTimeout(hideModal, 10000)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-sending {
    @include global-font;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 30px;
    left: 30px;
    height: 60px;
    background: $color-mine-shaft;
    border-radius: 3px;
    box-shadow: 0 0 20px rgba($color-accent, 0.25);
    color: $color-white;
    padding: 0 16px 0 20px;
    z-index: 100;
    cursor: default;

    &__close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 25px;
      height: 25px;
      font-size: 11px;
      cursor: pointer;
      transition: .2s;

      &:hover {
        opacity: 0.5;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/SendingStatus/SendingStatus.vue